import { all, fork } from 'redux-saga/effects';
import applicationSagas from './sagas/ApplicationSagas';
import documentsSagas from './sagas/DocumentsSagas';
import documentTypesSagas from './sagas/DocumentTypesSagas';
import guestsSagas from './sagas/GuestsSagas';
import invitesSagas from './sagas/InvitesSagas';

export default function* rootSaga() {
  yield all([
    fork(applicationSagas),
    fork(documentsSagas),
    fork(documentTypesSagas),
    fork(guestsSagas),
    fork(invitesSagas)
  ]);
}



// WEBPACK FOOTER //
// ./src/rootSaga.js